import React, { ReactNode } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { usePermissions } from '../query/api';

export type Permission = {
  section: string;
  function: string;
};

type PermissionWrapperType = 'conditionalRender' | 'displayNone' | 'opacity';

type PermissionWrapperProps = React.PropsWithChildren<{
  requiredPermissionSets?: Permission[][];
  // [[a,b],[c,d]] = has permission a&b or c&d
  requireSuperPlusAdmin?: boolean;
  type?: PermissionWrapperType;
  noPermissionChildren?: ReactNode;
}>

const connector = connect(
  (state: {
    getMyAccountInfo: any
    getMyAuthority: any
  }) => ({
    accountInfo: state?.getMyAccountInfo?.data,
  }),
  {},
);

type PermissionWrapperPropsWithRedux = ConnectedProps<typeof connector> & PermissionWrapperProps

const PermissionWrapper = ({
  requiredPermissionSets=[[]],
  requireSuperPlusAdmin = false,
  type = 'conditionalRender',
  noPermissionChildren = null,
  children,
}: PermissionWrapperPropsWithRedux) => {
  const { data } = usePermissions();
  const isSuperPlusAdmin = data?.data?.roleCode === 'SUPERPLUS_ADMIN';
  const hasPermission = requireSuperPlusAdmin ?
    isSuperPlusAdmin :
    requiredPermissionSets.some(permissionSet => permissionSet.every(
      permission => data?.data?.sections?.find(section => section.section === permission.section)?.functions?.includes(permission.function) ?? false)
    );

  switch (type) {
    case 'displayNone':
      return (
        <>
          <div style={hasPermission ? {} : { display: 'none' }}>{children}</div>
          <div style={hasPermission ? { display: 'none' } : {}}>{noPermissionChildren}</div>
        </>
      );
    case 'opacity':
      return (
        <>
          <div style={{ opacity: hasPermission ? 1 : 0 }}>{children}</div>
          <div style={{
            position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, opacity: hasPermission ? 0 : 1,
          }}
          >
            {noPermissionChildren}
          </div>
        </>
      );
    case 'conditionalRender':
    default:
      return hasPermission ? <>{children}</> : noPermissionChildren === null ? null : <>{noPermissionChildren}</>;
  }
};

export default connector(PermissionWrapper);
